export const VIDEO_FORMAT_TAGS = ['MP4', 'WEBM', 'AVI', 'MOV'];
